var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoreVert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_224_110",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0771484,
    y: 0.611816,
    width: 22.6629,
    height: 22.6629,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_224_110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4091 19.4973C10.8897 19.4973 10.4453 19.3125 10.0758 18.943C9.70559 18.5728 9.52051 18.1281 9.52051 17.6087C9.52051 17.0894 9.70559 16.6446 10.0758 16.2744C10.4453 15.9049 10.8897 15.7201 11.4091 15.7201C11.9284 15.7201 12.3732 15.9049 12.7434 16.2744C13.1129 16.6446 13.2977 17.0894 13.2977 17.6087C13.2977 18.1281 13.1129 18.5728 12.7434 18.943C12.3732 19.3125 11.9284 19.4973 11.4091 19.4973ZM11.4091 13.8316C10.8897 13.8316 10.4453 13.6465 10.0758 13.2763C9.70559 12.9068 9.52051 12.4623 9.52051 11.943C9.52051 11.4236 9.70559 10.9789 10.0758 10.6087C10.4453 10.2392 10.8897 10.0544 11.4091 10.0544C11.9284 10.0544 12.3732 10.2392 12.7434 10.6087C13.1129 10.9789 13.2977 11.4236 13.2977 11.943C13.2977 12.4623 13.1129 12.9068 12.7434 13.2763C12.3732 13.6465 11.9284 13.8316 11.4091 13.8316ZM11.4091 8.16583C10.8897 8.16583 10.4453 7.98075 10.0758 7.61059C9.70559 7.24106 9.52051 6.79661 9.52051 6.27725C9.52051 5.75789 9.70559 5.31345 10.0758 4.94391C10.4453 4.57375 10.8897 4.38867 11.4091 4.38867C11.9284 4.38867 12.3732 4.57375 12.7434 4.94391C13.1129 5.31345 13.2977 5.75789 13.2977 6.27725C13.2977 6.79661 13.1129 7.24106 12.7434 7.61059C12.3732 7.98075 11.9284 8.16583 11.4091 8.16583Z",
    fill: "#1C1B1F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreVert);
export default __webpack_public_path__ + "static/media/more_vert.250df639520f6a2d2b8139c904def760.svg";
export { ForwardRef as ReactComponent };